import React from 'react'

export function PointerLockIcon() {
  return (
    <svg
      width="23.612732mm"
      height="29.888321mm"
      viewBox="0 0 23.612732 29.888321"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(-33.843304,-152.14369)">
        <g>
          <g>
            <g>
              <g
                transform="matrix(1.0783806,-0.43536989,0.43536989,1.0783806,-81.646404,8.6591978)"
                style={{ strokeWidth: 0.702838, strokeDasharray: 'none' }}
              >
                <path
                  fill="none"
                  stroke="#000000"
                  strokeWidth="0.702838"
                  strokeDasharray="none"
                  strokeOpacity="1"
                  d="m 52.643814,181.67369 h 2.634544"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: '#000000',
                    strokeWidth: '0.702838',
                    strokeDasharray: 'none',
                  }}
                  d="m 52.649205,181.70151 0.0024,-10.81881"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: '#000000',
                    strokeWidth: '0.702838',
                    strokeDasharray: 'none',
                  }}
                  d="m 55.28774,181.68968 0.0024,-10.81881"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: '#000000',
                    strokeWidth: '0.702838',
                    strokeDasharray: 'none',
                  }}
                  d="m 52.565405,170.93166 -4.063389,0.25584"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: '#000000',
                    strokeWidth: '0.702838',
                    strokeDasharray: 'none',
                  }}
                  d="m 59.39359,171.16343 -4.063389,-0.25584"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: '#000000',
                    strokeWidth: '0.702838',
                    strokeDasharray: 'none',
                  }}
                  d="M 48.546371,171.27621 53.945403,155.1244"
                />
                <path
                  style={{
                    fill: 'none',
                    stroke: '#000000',
                    strokeWidth: '0.702838',
                    strokeDasharray: 'none',
                  }}
                  d="M 59.29629,171.213 53.89726,155.06119"
                />
              </g>
              <g transform="translate(-0.08870968,-14.016129)">
                <rect
                  style={{
                    fill: '#000000',
                    stroke: '#000000',
                    strokeWidth: '0.264999',
                    strokeDasharray: 'none',
                  }}
                  width="9.7580643"
                  height="9.0483866"
                  x="34.064514"
                  y="186.46773"
                />
                <ellipse
                  style={{
                    fill: '#cccccc',
                    stroke: '#000000',
                    strokeWidth: '0.264999',
                    strokeDasharray: 'none',
                  }}
                  cx="39.120968"
                  cy="191.03629"
                  rx="1.7741935"
                  ry="1.8185484"
                />
              </g>
              <path
                style={{
                  fill: 'none',
                  fillRule: 'evenodd',
                  stroke: '#000000',
                  strokeWidth: '1.1587',
                  strokeDasharray: 'none',
                }}
                d="m 31.18746,172.45289 c -0.426228,-2.46685 1.433629,-4.7492 3.84761,-5.12818 2.849952,-0.44742 5.469321,1.7085 5.875372,4.50476 0.02473,0.17028 0.04154,0.34171 0.05043,0.51355"
                transform="matrix(0.782771,0,0,0.782771,10.74733,37.403936)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
